import { render, staticRenderFns } from "./ChatRichTextEditor.vue?vue&type=template&id=981b277c&scoped=true"
import script from "./ChatRichTextEditor.vue?vue&type=script&lang=js"
export * from "./ChatRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./ChatRichTextEditor.vue?vue&type=style&index=0&id=981b277c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b277c",
  null
  
)

export default component.exports